<template>
  <page>
    <record-item
      v-for="(item, index) in recordList"
      :key="index"
      :item="item"
    ></record-item>
    <empty
      v-if="!recordList.length"
      desc="无反馈记录"
      class="empty-box"
      img="Empty"
    ></empty>
  </page>
</template>

<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import recordItem from './components/recordItem'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { companyId, cityId, deviceToken } from '@/defines/user'
export default {
  name: 'MarketResearch',
  components: { recordItem, Empty },
  beforeRouteEnter(to, form, next) {
    next(vm => {
      navBar.setTitle({
        text: '反馈记录'
      })
    })
  },
  data() {
    return {
      recordList: []
    }
  },
  async created() {
    try {
      const res = await API.marketResearch.getRecord({
        deviceToken,
        companyId,
        cityId
      })
      this.recordList = res
    } catch (error) {
      console.log(error)
    }
  },
  onLogin() {
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.empty-box {
  // margin-top: 4rem;
  height: 100vh;
}
</style>
